webpackJsonp([108],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	
	/* global require, ga, _hmt */
	__webpack_require__(10);
	
	__webpack_require__(8);
	
	__webpack_require__(13);
	
	__webpack_require__(19);
	
	__webpack_require__(12);
	
	__webpack_require__(3);
	
	__webpack_require__(9);
	
	__webpack_require__(22);
	
	__webpack_require__(17);
	
	__webpack_require__(18);
	
	__webpack_require__(16);
	
	__webpack_require__(71);
	
	__webpack_require__(1);
	
	__webpack_require__(6);
	
	__webpack_require__(4);
	
	__webpack_require__(24);
	
	__webpack_require__(11);
	
	__webpack_require__(15);
	
	__webpack_require__(21);
	
	__webpack_require__(2);
	
	
	/*
	 * flexslider
	 */
	
	$(function() {
	  var $carousel, $experience, $human, $human1, $nav, $nav_li, $navs, $navs0, $navs1, $navs2, $navs3, $navs4, $navss;
	  $human = $('#human');
	  $carousel = $('.carousel');
	  $nav = $('.nav');
	  $nav_li = $nav.find('li');
	  $human.flexslider({
	    animation: 'slide',
	    animationLoop: false,
	    controlNav: false,
	    itemWidth: 254,
	    itemMargin: 28,
	    moflexsliderve: 1,
	    prevText: "",
	    nextText: ""
	  });
	  $human1 = $('#human1');
	  $human1.flexslider({
	    animation: 'slide',
	    animationLoop: false,
	    controlNav: false,
	    itemWidth: 340,
	    itemMargin: 39,
	    move: 3,
	    prevText: "",
	    nextText: "",
	    useCSS: true
	  });
	  $experience = $('#experience');
	  $experience.flexslider({
	    animation: 'slide',
	    animationLoop: false,
	    controlNav: false,
	    itemWidth: 1100,
	    itemMargin: 0,
	    move: 1,
	    prevText: "",
	    nextText: "",
	    useCSS: true
	  });
	  $navs = $('#navs');
	  $navs.flexslider({
	    animation: 'slide',
	    animationLoop: false,
	    controlNav: false,
	    itemWidth: 1100,
	    itemMargin: 0,
	    move: 1,
	    prevText: "",
	    nextText: ""
	  });
	  $navss = $('#navss');
	  $navss.flexslider({
	    animation: 'slide',
	    animationLoop: false,
	    controlNav: false,
	    itemWidth: 1100,
	    itemMargin: 0,
	    move: 1,
	    prevText: "",
	    nextText: ""
	  });
	  $navs0 = $('#navs0');
	  $navs0.flexslider({
	    animation: 'slide',
	    animationLoop: false,
	    controlNav: false,
	    itemWidth: 1100,
	    itemMargin: 0,
	    prevText: "",
	    nextText: ""
	  });
	  $navs1 = $('#navs1');
	  $navs1.flexslider({
	    animation: 'slide',
	    animationLoop: false,
	    controlNav: false,
	    itemWidth: 1100,
	    itemMargin: 0,
	    move: 1,
	    prevText: "",
	    nextText: ""
	  });
	  $navs2 = $('#navs2');
	  $navs2.flexslider({
	    animation: 'slide',
	    animationLoop: false,
	    controlNav: false,
	    itemWidth: 1100,
	    itemMargin: 0,
	    move: 1,
	    prevText: "",
	    nextText: ""
	  });
	  $navs3 = $('#navs3');
	  $navs3.flexslider({
	    animation: 'slide',
	    animationLoop: false,
	    controlNav: false,
	    itemWidth: 1100,
	    itemMargin: 0,
	    move: 1,
	    prevText: "",
	    nextText: ""
	  });
	  $navs4 = $('#navs4');
	  $navs4.flexslider({
	    animation: 'slide',
	    animationLoop: false,
	    controlNav: false,
	    itemWidth: 1100,
	    itemMargin: 0,
	    move: 1,
	    prevText: "",
	    nextText: ""
	  });
	  $carousel.slick({
	    centerMode: true,
	    centerPadding: '0px',
	    slidesToShow: 3,
	    speed: 600,
	    arrows: false
	  });
	  $carousel.css('opacity', '1');
	  $('#slide3d').slideCarsousel({
	    slideType: '3d',
	    indicatorEvent: 'mouseover'
	  });
	  $('#slide3d2').slideCarsousel({
	    slideType: '3d',
	    indicatorEvent: 'mouseover'
	  });
	  return $('#slide3d3').slideCarsousel({
	    slideType: '3d',
	    indicatorEvent: 'mouseover'
	  });
	});
	
	
	/*
	 * 5不限(切换)
	 */
	
	(function() {
	  var $autoplay, $imageContainer, $imageOptions, $material1, $pagination, $paginations, $speed, $swiperI, $swiperT, $textContainer, $textContainerswiper, $textOptions, theSwitch;
	  if ($('.material1').length > 0) {
	    $material1 = $('.material1');
	    $imageContainer = $material1.find('.image');
	    $textContainer = $material1.find('.text');
	    $textContainerswiper = $material1.find('.text ul');
	    $paginations = $material1.find('.material_nav1');
	    $pagination = $material1.find('.material_nav1 li');
	    $speed = 800;
	    $autoplay = 5000;
	    $imageOptions = {
	      autoplay: $autoplay,
	      speed: $speed,
	      loop: true,
	      effect: 'fade'
	    };
	    $swiperI = new Swiper($imageContainer, $imageOptions);
	    $textOptions = {
	      autoplay: $autoplay,
	      autoHeight: true,
	      speed: $speed,
	      effect: 'fade',
	      fade: {
	        crossFade: true
	      },
	      loop: true,
	      onSlideChangeStart: function(swiper) {
	        var $index;
	        $index = swiper.activeIndex;
	        if ($index >= $pagination.length) {
	          $index = $index - $pagination.length;
	        }
	        $pagination.removeClass('active');
	        $pagination.eq($index - 1).addClass('active');
	        return $swiperI.slideTo($index);
	      }
	    };
	    $swiperT = new Swiper($textContainer, $textOptions);
	    theSwitch = function() {
	      var $this;
	      $this = $(this);
	      $swiperI.slideTo($this.index() + 1);
	      $swiperT.slideTo($this.index() + 1);
	      $this.siblings().removeClass('active');
	      return $this.addClass('active');
	    };
	    return $pagination.on('click', theSwitch);
	  }
	})();
	
	
	/*
	 * afterSale toggle
	 */
	
	(function() {
	  var $afterSale_li, $topbg_nav, scroll;
	  $afterSale_li = $('.afterSale ul li');
	  $afterSale_li.hover(function(evt) {
	    var $me;
	    evt.preventDefault();
	    $me = $(this);
	    $afterSale_li.removeClass('active');
	    return $me.addClass('active');
	  });
	
	  /*
	   * 导航浮动浏览器
	   */
	  $topbg_nav = $('.topbg-nav');
	  $topbg_nav.affix({
	    offset: {
	      top: 684
	    }
	  });
	
	  /*
	   * 滚动锚点
	   */
	  scroll = __webpack_require__(31);
	  return $topbg_nav.find('li a').on('click', function(evt) {
	    var $me;
	    evt.preventDefault();
	    $me = $(this);
	    return scroll.scrollTo($($me.attr('href')));
	  });
	})();
	
	(function() {
	  var $height, $leftFloat, $mfdh, $yuyuefix, iHeight;
	  $leftFloat = $('.left-float');
	  $yuyuefix = $('.yuyuefix');
	  $mfdh = $('.mfdh');
	  if ($yuyuefix.length > 0) {
	    iHeight = $leftFloat.offset().top;
	    $height = $("body").height() - ($(window).height() - 136);
	    return $(window).scroll(function() {
	      var scrollTop;
	      $mfdh.hide();
	      $mfdh.stop().animate({
	        right: -150
	      });
	      scrollTop = $(window).scrollTop();
	      if ($height <= scrollTop) {
	        $yuyuefix.stop().animate({
	          bottom: -85
	        }, 50);
	      } else if (480 <= scrollTop) {
	        $leftFloat.addClass('show');
	        $yuyuefix.stop().animate({
	          bottom: 0
	        }, 50);
	      } else {
	        $leftFloat.removeClass('show');
	        $yuyuefix.stop().animate({
	          bottom: -85
	        }, 50);
	      }
	      if ($('#left-float').hasClass('show')) {
	        return $('.rengongkefu').addClass('full');
	      } else {
	        return $('.rengongkefu').removeClass('full');
	      }
	    });
	  }
	})();


/***/ },

/***/ 71:
3

});


/** WEBPACK FOOTER **
 ** content-jingxuan.78b9828bc95dc8a78a7a.js
 **/